import wrapperHOC from "@Utils/wrapperHOC";
import { memo } from "react";
import ContentHeroSection from "@Components/ContentHeroSection";
import type { HeroItem } from "@Components/ContentHeroSection";

interface BlogHeroSectionProps {
  blogs: HeroItem[];
}

const BlogHeroSection = ({ blogs }: BlogHeroSectionProps) => (
  <ContentHeroSection items={blogs} basePath="/blog" />
);

export default wrapperHOC(memo(BlogHeroSection), {
  componentName: "BlogHeroSection-Blog",
  showForChina: true,
});
